var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphToday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m251.988 512h-40c-19.851 0-36-16.149-36-36v-248c0-19.851 16.149-36 36-36h40c19.851 0 36 16.149 36 36v248c0 19.851-16.15 36-36 36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.988 512h-40c-19.851 0-36-16.149-36-36v-168c0-19.851 16.149-36 36-36h40c19.851 0 36 16.149 36 36v168c0 19.851-16.15 36-36 36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.988 512h-40c-19.851 0-36-16.149-36-36v-332h-21.98c-10.276 0-19.328-5.8-23.622-15.136s-2.807-19.982 3.881-27.785c.076-.089.154-.178.232-.265l85.573-95.492c3.035-3.387 7.368-5.322 11.916-5.322s8.88 1.935 11.916 5.322l85.573 95.492c.079.087.156.176.232.265 6.688 7.802 8.175 18.449 3.881 27.785s-13.346 15.136-23.622 15.136h-21.98v332c0 19.851-16.15 36-36 36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphToday);
export default __webpack_public_path__ + "static/media/graph_today.cb82b30c.svg";
export { ForwardRef as ReactComponent };